/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2, useTheme } from '@coursera/cds-core';

import _t from 'i18n!nls/degree-home';

export const Pill: React.FunctionComponent<{
  'data-testid'?: string;
  label: React.ReactChild;
  textColor: string;
  backgroundColor: string;
}> = ({ label, textColor, backgroundColor, ...otherProps }) => {
  const theme = useTheme();
  return (
    <div
      data-testid={otherProps['data-testid']}
      css={css`
        background-color: ${backgroundColor};
        padding: ${theme.spacing(4)};
        width: fit-content;
        border-radius: ${theme.spacing(4)};
      `}
    >
      <Typography2 component="h4" variant="subtitleMedium" style={{ color: textColor }}>
        {label}
      </Typography2>
    </div>
  );
};

export const LivePill: React.FunctionComponent<{}> = () => {
  const theme = useTheme();

  return (
    <Pill
      label={['•', _t('Live Now')].join(' ')}
      textColor={theme.palette.red[700]}
      backgroundColor={theme.palette.red[100]}
    />
  );
};

export default Pill;
